import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { useAdsType } from '@wix/da-ads/pkg/useAdsType';
export function useShowMobileAd(deviation) {
    const deviationType = getDeviationType(deviation);
    const { adsEnabled  } = useContext(SessionContext);
    const isMobile = useContext(MobileContext);
    const adsEnabledDeviation = [
        DeviationTypes.IMAGE
    ].includes(deviationType);
    const adsType = useAdsType();
    return {
        showVideoBtfAd: isMobile && adsEnabled && adsEnabledDeviation && adsType === 'anon',
        showAtfAd: isMobile && adsEnabled && adsEnabledDeviation && adsType === 'anon',
        showAdhesionAd: isMobile && adsEnabled
    };
}
